import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import api3000 from '../../services/api3000';
import api3004 from '../../services/api3004';
import {SelectStatus, SelectPayment} from '../SelectStatus'
import InputKmRealizado from '../InputKmRealizado';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: rgba(255, 255, 255, 0.9);
  padding: 2rem;
  border-radius: 12px;
  width: 90%;
  max-width: 1000px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  position: relative;
  animation: fadeIn 0.3s ease;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: scale(0.98); }
    to { opacity: 1; transform: scale(1); }
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 20px;
  border: 2px solid red;
  background-color: transparent;
  color: red;
  font-size: 14px;
  padding: 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.2s ease-in-out;

  &:hover,
  &:active {
    background-color: red;
    color: white;
    border-color: white;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    padding: 4px 10px;
  }
`;

const Title = styled.h2`
  margin-bottom: 24px;
  font-size: 28px;
  color: #222;
  text-align: center;

  @media (max-width: 480px) {
    font-size: 22px;
  }
`;

const SectionTitle = styled.h3`
  margin: 30px 0 10px;
  font-size: 18px;
  color: #333;
  border-left: 4px solid #007bff;
  padding-left: 10px;
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px 24px;
  margin-bottom: 1rem;

  @media (max-width: 480px) {
    gap: 12px 16px;
  }
`;

const InfoItem = styled.div`
  background-color: #f9f9f9;
  padding: 10px 14px;
  border-radius: 6px;
  border: 1px solid #e0e0e0;

  strong {
    display: block;
    font-size: 13px;
    color: #555;
    margin-bottom: 4px;
  }

  span {
    font-size: 14px;
    color: #222;
    word-break: break-word;
  }

  @media (max-width: 480px) {
    strong, span {
      font-size: 13px;
    }
  }
`;

const Select = styled.select`
  padding: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
`;

const OrcamentoDetailsModal = ({ orcamento, onClose, $load }) => {
  const [criadorNome, setCriadorNome] = useState('');
  const [pouso, setPouso] = useState(0);
  const [statusPagamento, setStatusPagamento] = useState(orcamento.status_pagamento);
  const [statusViagem, setStatusViagem] = useState(orcamento.status_viagem);
  const [onibus, setOnibus] = useState('');

  const formatDate = (data) => {
    if (!data) return '';
    const d = new Date(data);
    const localDate = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    return localDate.toLocaleDateString('pt-BR');
  };
  
  const formatNum = (num) =>
    parseFloat(num || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 });

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (orcamento.criado_por) {
      api3000.get(`/api/users/${orcamento.criado_por}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((response) => {
          setCriadorNome(response.data.nome || 'Desconhecido');
        })
        .catch(() => setCriadorNome('Erro ao carregar'));
    }

    setPouso(orcamento.pagador_pouso === "esportiva" || orcamento.pagador_pouso === "cliente" ? 1 : 0);
  }, [orcamento.criado_por, orcamento.pagador_pouso]);

  useEffect(() => {
    if (!orcamento.onibus_id) return;

    api3004.get(`/api/onibus/${orcamento.onibus_id}`)
      .then((response) => {
        setOnibus(response.data || 'Não encontrado');
      })
      .catch(() => {
        setOnibus('Erro ao carregar');
      });
  }, [orcamento.onibus_id]);

  return (
    <ModalOverlay>
      <ModalContent>
        <CloseButton onClick={onClose}>Fechar</CloseButton>
        <Title>Detalhes da Viagem</Title>

        <SectionTitle>Dados Gerais</SectionTitle>
        <InfoGrid>
          <InfoItem><strong>ID:</strong><span>{orcamento.id}</span></InfoItem>
          <InfoItem><strong>Cliente:</strong><span>{orcamento.cliente_nome}</span></InfoItem>
          <InfoItem><strong>Origem:</strong><span>{orcamento.origem}</span></InfoItem>
          <InfoItem><strong>Destino:</strong><span>{orcamento.destino}</span></InfoItem>
          <InfoItem><strong>KM Total:</strong><span>{formatNum(orcamento.km_total)} km</span></InfoItem>
          {
            statusViagem === "executado" && (
              <InfoItem>
                <strong>KM Realizado:</strong>
                <InputKmRealizado
                  $km={orcamento.km_total_realizado}
                  $orcamento_id={orcamento.id}
                  $load={$load}
                  $format={formatNum}
                />
              </InfoItem>
          )}
          <InfoItem><strong>Embarque:</strong><span>{formatNum(orcamento.km_embarque)} km</span></InfoItem>
          <InfoItem><strong>Valor por KM:</strong><span>{formatNum(orcamento.valor_km)} R$</span></InfoItem>
          <InfoItem><strong>Consumo Médio:</strong><span>{formatNum(orcamento.consumo_medio)} km/L</span></InfoItem>
          <InfoItem><strong>Valor Litro Combustível:</strong><span>{formatNum(orcamento.valor_litro_combustivel)} R$</span></InfoItem>

          {(orcamento.status_viagem === 'reservado' ||
            (orcamento.status_viagem === 'executado' && orcamento.motorista)) && (
            <>
              <InfoItem>
                <strong>Motorista:</strong>
                <span>{orcamento.motorista}</span>
              </InfoItem>

              <InfoItem>
                <strong>Ônibus Prefixo:</strong>
                <span>{onibus.prefixo}</span>
              </InfoItem>

              <InfoItem>
                <strong>Ônibus Placa:</strong>
                <span>{onibus.placa}</span>
              </InfoItem>
            </>
          )}

          {(orcamento.status_viagem === 'terceiro' ||
            (orcamento.status_viagem === 'executado' && orcamento.nome_terceiro)) && (
            <InfoItem>
              <strong>Nome do Terceiro:</strong>
              <span>{orcamento.nome_terceiro}</span>
            </InfoItem>
          )}
        </InfoGrid>

        <SectionTitle>Custos e Receita</SectionTitle>
        <InfoGrid>
          {pouso ? (
            <>
              <InfoItem style={{ gridColumn: '1 / -3' }}><strong>Quem Paga o Pouso:</strong><span>{orcamento.pagador_pouso}</span></InfoItem>
              <InfoItem style={{ gridColumn: '3 / -1' }}><strong>Valor dia Pouso:</strong><span>{formatNum(orcamento.valor_dia_pouso)} R$</span></InfoItem>
            </>
          ) : (
            <InfoItem style={{ gridColumn: '1 / -1' }}><strong>Pouso:</strong><span>{pouso ? 'Sim' : 'Não'}</span></InfoItem>
          )}
          <InfoItem style={{ gridColumn: '1 / -3' }}><strong>Quem Paga a Alimentação:</strong><span>{orcamento.pagador_alimentacao}</span></InfoItem>
          <InfoItem style={{ gridColumn: '3 / -1' }}><strong>Valor dia Alimentação:</strong><span>{formatNum(orcamento.valor_dia_alimentacao)} R$</span></InfoItem>
          <InfoItem style={{ gridColumn: '1 / -3' }}><strong>Quem Paga o Estacionamento:</strong><span>{orcamento.pagador_estacionamento}</span></InfoItem>
          <InfoItem style={{ gridColumn: '3 / -1' }}><strong>Valor dia Estacionamento:</strong><span>{formatNum(orcamento.valor_dia_estacionamento)} R$</span></InfoItem>
          <InfoItem style={{ gridColumn: '1 / -3' }}><strong>Valor Pedágio:</strong><span>{formatNum(orcamento.valor_pedagio)} R$</span></InfoItem>
          <InfoItem style={{ gridColumn: '3 / -1' }}><strong>Caixa D'Água:</strong><span>{formatNum(orcamento.caixa_agua)} R$</span></InfoItem>
          {orcamento.diaria > 0 && (
            <InfoItem><strong>Diária:</strong><span>{formatNum(orcamento.diaria)} R$</span></InfoItem>
          )}
          <InfoItem><strong>% Garagem:</strong><span>{formatNum(orcamento.perc_garagem)}%</span></InfoItem>
          <InfoItem><strong>% Manutenção:</strong><span>{formatNum(orcamento.perc_manutencao)}%</span></InfoItem>
          <InfoItem><strong>% Folha Salarial:</strong><span>{formatNum(orcamento.perc_folha_salarial)}%</span></InfoItem>
          <InfoItem><strong>% Comissão Motorista:</strong><span>{formatNum(orcamento.perc_comissao_motorista)}%</span></InfoItem>
        </InfoGrid>

        <SectionTitle>Percentuais e Cálculos</SectionTitle>
        <InfoGrid>
          <InfoItem><strong>Valor Orçado:</strong><span>{formatNum(orcamento.valor_orcado)} R$</span></InfoItem>
          <InfoItem><strong>Custo Total:</strong><span>{formatNum(orcamento.custo_total)} R$</span></InfoItem>
          <InfoItem><strong>Receita:</strong><span>{formatNum(orcamento.receita)} R$</span></InfoItem>
          <InfoItem><strong>Margem:</strong><span>{formatNum(orcamento.margem * 100)}%</span></InfoItem>
        </InfoGrid>

        <SectionTitle>Datas e Status</SectionTitle>
        <InfoGrid>
          <InfoItem><strong>Pagamento:</strong>
              <SelectPayment
                $details={true}
                $orcamento_id={orcamento.id}
                $status_pagamento={statusPagamento}
                $load={$load}
                $setNewObj={setStatusPagamento}
              />
          </InfoItem>
          <InfoItem><strong>Status:</strong>
              <SelectStatus 
                $details={true}
                $orcamento_id={orcamento.id}
                $status_viagem={statusViagem} 
                $load={$load}
                $setNewObj={setStatusViagem}
                $data_inicio={orcamento.data_inicio}
                $data_fim={orcamento.data_fim}
              />
          </InfoItem>
          <InfoItem><strong>Data Início:</strong><span>{formatDate(orcamento.data_inicio)}</span></InfoItem>
          <InfoItem><strong>Data Fim:</strong><span>{formatDate(orcamento.data_fim)}</span></InfoItem>
          <InfoItem><strong>Horário de Saída:</strong><span>{orcamento.horario_saida}</span></InfoItem>
          <InfoItem><strong>Horário de Retorno:</strong><span>{orcamento.horario_retorno}</span></InfoItem>
          <InfoItem><strong>Status:</strong><span>{orcamento.status}</span></InfoItem>
          <InfoItem><strong>Criado em:</strong><span>{formatDate(orcamento.criado_em)}</span></InfoItem>
          <InfoItem><strong>Atualizado em:</strong><span>{formatDate(orcamento.atualizado_em)}</span></InfoItem>
          <InfoItem><strong>Criado por:</strong><span>{criadorNome}</span></InfoItem>
          <InfoItem><strong>Qtd. Dias de Viagem:</strong><span>{orcamento.qtd_dias_viagem}</span></InfoItem>
          <InfoItem><strong>Data Pagamento:</strong><span>{formatDate(orcamento.data_pagamento)}</span></InfoItem>
          <InfoItem><strong>Data Sinal:</strong><span>{formatDate(orcamento.data_sinal)}</span></InfoItem>
        </InfoGrid>
      </ModalContent>
    </ModalOverlay>
  );
};

export default OrcamentoDetailsModal;
